@if (!field.hidden) {
  <div animate.enter="fade-in" class="flex flex-col w-full">
    <div class="flex flex-row items-center w-full">
      @if (field.browserOpts.inLineWithCaption) {
        <div class="mr-2">
          @if (!field.required) {
            <div class="leading-6 font-medium">{{ field.label | localize }}</div>
          }
          @if (field.required) {
            <div class="leading-6 font-medium">{{ field.label | localize }}</div>
          }
          @if (field.hint) {
            <div class="text-md text-secondary">{{ field.hint | localize }}</div>
          }
        </div>
      }
      <div class="flex flex-col w-full">
        <div class="flex flex-row justify-end -mb-4 mt-2">
          <mat-button-toggle-group [(ngModel)]="selectedLang">
            @for (lang of availableLangs; track lang) {
              <mat-button-toggle [value]="lang.id">
                <mat-icon class="icon-size-5 mr-2"
                  [svgIcon]="field.control.value[lang.id] ? 'heroicons_solid:star' : 'heroicons_outline:star'">
                </mat-icon>
                {{ lang.label }}
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>
        @if (!field.browserOpts?.inLineWithCaption) {
          <div class="mb-2">
            @if (!field.required) {
              <div class="leading-6 font-medium">{{ field.label | localize }}</div>
            }
            @if (field.required) {
              <div class="leading-6 font-medium">{{ field.label | localize }} *</div>
            }
            @if (field.hint) {
              <div class="text-md text-secondary">{{ field.hint | localize }}</div>
            }
          </div>
        }
        @if (showEditor()) {
          <editor class="tinymce" [init]="initOptions" [formControl]="field.control | dTypeFormControl:selectedLang"
            [class.invalid]="!field.readonly && field.control.touched && field.control.errors?.required">
          </editor>
        }
        @if (!field.hidden && !field.readonly) {
          @if (field.control.touched && field.control.errors?.required) {
            <div
              class="text-sm text-warn leading-none font-medium mt-2">
              {{ 'errorLocaleTextRequired' | transloco }}
            </div>
          }
          <ng-container
            *ngTemplateOutlet="errors; context: { $implicit: field.control | dTypeFormControl:selectedLang }">
          </ng-container>
        }
      </div>
    </div>
  </div>
}

<ng-template #errors let-control>
  @if (!control.disabled && control.touched && control.errors) {
    @if (control.errors.minlength) {
      <div class="text-sm text-warn leading-none font-medium mt-2">
        {{ 'errorMinLengthField' | transloco:{ requiredLength: control.errors.minlength.requiredLength } }}
      </div>
    }
    @if (control.errors.maxlength) {
      <div class="text-sm text-warn leading-none font-medium mt-2">
        {{ 'errorMaxLengthField' | transloco:{ requiredLength: control.errors.maxlength.requiredLength } }}
      </div>
    }
  }
</ng-template>